import React from 'react';
import { ShareLink, ShareLinkWrapper } from '../styles/share-link.style';
import gaEvent from '../../../utils/gaEvent';

/**
 * Twitter Click
 * @param {string} tweet Tweet hashtag
 */
const shareClick = (tweet) => {
  gaEvent({
    eventCategory: 'Nav',
    eventAction: 'Click',
    eventLabel: tweet,
  });
};


/**
 * Copyright Component
 * @param {object} props Incoming Props
 * @returns {XML} Copyright Component
 */
const ShareButton = ({ mobile, desktop }) => (
  <ShareLinkWrapper>
    <ShareLink
      className={`nav__${mobile ? 'mobile-' : ''}link scroll-link ${desktop ? 'desktop-only' : ''}`}
      // data-target="share"
      // href="https://twitter.com/intent/tweet?hashtags=XFLRewriteTheRules"
      name="share"
      data-event="#XFL2020"
      data-label="XFL2020"
      aria-label="Share Link"
      // target="_blank"
      onClick={() => shareClick('#XFL2020')}
      to="/#share"
    >
      { '#XFL' }
      <span className="button-red">2020</span>
    </ShareLink>
  </ShareLinkWrapper>
);

export default ShareButton;



// WEBPACK FOOTER //
// ./src/components/share/components/share-link.js